app.component('bigSwitch', {
	templateUrl: 'app/common/component/bigswitch/big_switch.html',
    bindings: {
        trueLabel : '@',
        falseLabel : '@',
        swModel : '=',
    }
});